<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoListar">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoListar">
            <div class="formgroup" *ngIf="permissaoInserir">
                <div class="p-fluid p-formgrid grid justify-content-between">
                    <div class="field col-12 sm:col-2">
                        <button
                            pButton
                            pRipple
                            routerLink="/apps/comanda/"
                            label="Novo"
                            icon="pi pi-plus"
                            class="p-button-outlined sm:w-9rem"
                        ></button>
                    </div>
                    <div class="field col-12 sm:col-4 flex justify-content-end">
                        <button
                            pButton
                            pRipple
                            type="button"
                            pTooltip="Sangrias"
                            icon="pi pi-chart-line"
                            class="p-button-raised p-button-help mr-1"
                            (click)="abrirDialogSangriaListar()"
                            style="box-shadow: none"
                        ></button>
                        <button
                            pButton
                            pRipple
                            type="button"
                            pTooltip="Saídas"
                            icon="pi pi-reply"
                            class="p-button-raised p-button-warning mr-1"
                            (click)="abrirDialogSaida()"
                            style="box-shadow: none"
                        ></button>
                        <button
                            pButton
                            pRipple
                            type="button"
                            pTooltip="Pagamentos"
                            icon="pi pi-dollar"
                            class="p-button-raised p-button-info"
                            style="box-shadow: none"
                            (click)="abrirDialogPagamentosListar()"
                        ></button>
                    </div>
                </div>
            </div>
            <div class="flex justify-content-center" *ngIf="isExibirSpinnerPrincipal()">
                <p-progressSpinner></p-progressSpinner>
            </div>
            <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                <p-messages
                    [(value)]="messages"
                    [enableService]="false"
                    [closable]="true"
                ></p-messages>
            </div>
            <p-table
                #dt1
                [value]="listaComandas"
                dataKey="id"
                [rows]="itensPaginados ? itensPaginados.size : 0"
                [loading]="loadingTable"
                [rowHover]="true"
                [paginator]="true"
                (onLazyLoad)="onLazyLoad($event)"
                [totalRecords]="itensPaginados ? itensPaginados.totalElements : 0"
                [lazy]="true"
                [showCurrentPageReport]="true"
                responsiveLayout="stack"
                styleClass=" p-datatable-sm"
                *ngIf="!isExibirSpinnerPrincipal()"
                currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros"
            >
                <ng-template pTemplate="caption">
                    <div class="flex justify-content-between flex-column sm:flex-row">
                        <div class="flex flex-column sm:flex-row w-full">
                            <div class="p-fluid sm:mr-2">
                                <p-dropdown
                                    [options]="listaCaixasAbertos"
                                    optionLabel="label"
                                    optionValue="value"
                                    emptyFilterMessage="Nenhum registro"
                                    name="caixas"
                                    ngModel
                                    #caixas="ngModel"
                                    [(ngModel)]="caixaSelecionado"
                                    (onChange)="alterarCaixa()"
                                    emptyMessage="Nenhum registro"
                                ></p-dropdown>
                            </div>
                            <div class="p-fluid mt-2 sm:mt-0">
                                <p-dropdown
                                    [options]="listaSitucoesStatus"
                                    emptyFilterMessage="Nenhum registro"
                                    name="situacao"
                                    ngModel
                                    #situacao="ngModel"
                                    [(ngModel)]="statusComandaSelecionado"
                                    (onChange)="listarComandas()"
                                    emptyMessage="Nenhum registro"
                                ></p-dropdown>
                            </div>
                        </div>

                        <div class="flex justify-content-end flex-column sm:flex-row">
                            <div class="p-inputgroup p-fluid mt-2 sm:mt-0">
                                <div class="flex w-full sm:w-auto">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input
                                            pInputText
                                            type="text"
                                            #filter
                                            (input)="buscar($event)"
                                            placeholder="Buscar"
                                            class="w-full"
                                        />
                                    </span>
                                    <span class="ml-2">
                                        <button
                                            pButton
                                            class="p-button-outlined"
                                            icon="pi pi-filter-slash"
                                            pTooltip="Limpar Filtros"
                                            (click)="limpar()"
                                        ></button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="controleComanda">
                            Controle
                            <p-sortIcon field="controleComanda"></p-sortIcon>
                        </th>
                        <th pSortableColumn="cliente.nome">
                            Cliente
                            <p-sortIcon field="cliente.nome"></p-sortIcon>
                        </th>
                        <th pSortableColumn="numeroComanda">
                            Comanda
                            <p-sortIcon field="numeroComanda"></p-sortIcon>
                        </th>
                        <th pSortableColumn="dataCriacao">
                            Hora
                            <p-sortIcon field="dataCriacao"></p-sortIcon>
                        </th>
                        <th>Status</th>
                        <th style="text-align: center">
                            <div>Ações</div>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>
                            {{ item.controleComanda.toString().padStart(7, "0") }}
                        </td>
                        <td>
                            {{ item.cliente.nome }}
                        </td>
                        <td>
                            {{ item.numeroComanda }}
                        </td>
                        <td>
                            {{ item.dataCriacao | date: "HH:mm" }}
                        </td>
                        <td>
                            <span
                                class="product-badge bg-blue-600 admihair-text-white"
                                *ngIf="item.statusComanda === 'ABERTA'"
                            >
                                ABERTA
                            </span>
                            <span
                                class="product-badge bg-cyan-600 admihair-text-white"
                                *ngIf="item.statusComanda === 'REABERTA'"
                            >
                                REABERTA
                            </span>
                            <span
                                class="product-badge bg-green-600 admihair-text-white"
                                *ngIf="item.statusComanda === 'FECHADA'"
                            >
                                FECHADA
                            </span>
                            <span
                                class="product-badge bg-red-600 admihair-text-white"
                                *ngIf="item.statusComanda === 'CANCELADA'"
                            >
                                CANCELADA
                            </span>
                        </td>
                        <td style="text-align: center">
                            <div>
                                <button
                                    *ngIf="permissaoDetalhar && item.statusComanda !== 'CANCELADA'"
                                    pButton
                                    pRipple
                                    pTooltip="Detalhar"
                                    (click)="
                                        redirecionarPagina('/apps/comanda/detalhar/' + item.id)
                                    "
                                    icon="pi pi-eye"
                                    class="p-button-info mr-2 mb-2"
                                ></button>
                                <button
                                    *ngIf="permissaoDetalhar && item.statusComanda === 'CANCELADA'"
                                    pButton
                                    pRipple
                                    icon="pi pi-eye"
                                    class="p-button-info mr-2 mb-2"
                                    disabled
                                ></button>
                                <button
                                    *ngIf="permissaoEditar && verificarEditar(item.statusComanda)"
                                    pButton
                                    pRipple
                                    pTooltip="Editar"
                                    (click)="redirecionarPagina('/apps/comanda/' + item.id)"
                                    icon="pi pi-pencil"
                                    class="p-button-success mr-2 mb-2"
                                ></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">Nenhum registro encontrado.</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="loadingbody">
                    <tr>
                        <td colspan="7">Carregando clientes. Por favor aguarde.</td>
                    </tr>
                </ng-template>
            </p-table>
            <p-confirmDialog></p-confirmDialog>

            <p-dialog
                header="Sangrias"
                [(visible)]="exibirDialogSangriaListar"
                [modal]="true"
                [style]="{ width: '40rem' }"
                [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
                [draggable]="false"
                [resizable]="false"
                [closable]="true"
            >
                <ng-template pTemplate="content">
                    <div class="formgroup">
                        <div class="p-fluid p-formgrid grid" *ngIf="!caixaSelecionado">
                            <div class="field col-12 md:col-12 shadow-2 border-round-lg">
                                <div class="flex flex-row gap-4 md:flex-column overflow-auto">
                                    <div class="justify-content-center mt-5">
                                        <label for="">
                                            <i class="pi pi-times"></i>
                                            Por favor, selecione um Caixa
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid grid" *ngIf="caixaSelecionado">
                            <div
                                class="field col-12 md:col-4"
                                style="padding-bottom: 5px; margin-bottom: 5px"
                            >
                                <button
                                    pButton
                                    pRipple
                                    label="Novo"
                                    (click)="abrirDialogSangriaInserir()"
                                    icon="pi pi-plus"
                                    class="p-button-outlined"
                                ></button>
                            </div>
                            <div class="field col-12 md:col-12" *ngIf="messagemVisivelDialog">
                                <p-messages
                                    [(value)]="messagesDialog"
                                    [enableService]="false"
                                    [closable]="true"
                                ></p-messages>
                            </div>
                            <div
                                class="field col-12 md:col-12"
                                style="padding: 1px 14px; margin-bottom: 0px"
                            >
                                <label for="">Data</label>
                                <label for="" class="form-control">
                                    {{ caixaSelecionado.dataCaixa | date: "dd/MM/yyyy" }}
                                </label>
                            </div>

                            <div
                                class="field col-12 md:col-12"
                                style="padding: 0px 14px; margin-bottom: 0px"
                            >
                                <p-table
                                    #dtSangrias
                                    [value]="listaSangrias"
                                    dataKey="id"
                                    [rows]="5"
                                    [rowHover]="true"
                                    [loading]="loadingSangriaListar"
                                    styleClass="p-datatable-gridlines"
                                    [paginator]="true"
                                    [globalFilterFields]="['descricao']"
                                    responsiveLayout="scroll"
                                    styleClass=" p-datatable-sm"
                                >
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th pSortableColumn="tipoPagamentoOrigem.descricao">
                                                De
                                                <p-sortIcon
                                                    field="tipoPagamentoOrigem.descricao"
                                                ></p-sortIcon>
                                            </th>
                                            <th pSortableColumn="tipoPagamentoDestino.descricao">
                                                Para
                                                <p-sortIcon
                                                    field="tipoPagamentoDestino.descricao"
                                                ></p-sortIcon>
                                            </th>
                                            <th pSortableColumn="valorTransferido">
                                                Valor
                                                <p-sortIcon field="valorTransferido"></p-sortIcon>
                                            </th>
                                            <th style="text-align: center">
                                                <div>Ações</div>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-item>
                                        <tr>
                                            <td>
                                                {{ item.tipoPagamentoOrigem.descricao }}
                                            </td>
                                            <td>
                                                {{ item.tipoPagamentoDestino.descricao }}
                                            </td>
                                            <td>
                                                {{ item.valorTransferido | currency: "BRL" }}
                                            </td>

                                            <td style="text-align: center">
                                                <button
                                                    pButton
                                                    pRipple
                                                    pTooltip="Excluir"
                                                    icon="pi pi-trash"
                                                    class="p-button-danger"
                                                    (click)="excluirSangria(item.id)"
                                                ></button>
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="emptymessage">
                                        <tr>
                                            <td colspan="7">Nenhum registro encontrado.</td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="loadingbody">
                                        <tr>
                                            <td colspan="7">
                                                Carregando grupos. Por favor aguarde.
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </p-dialog>
            <p-dialog
                header="Sangrias"
                [(visible)]="exibirDialogSangria"
                [modal]="true"
                [style]="{ width: '40rem' }"
                [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
                [draggable]="false"
                [resizable]="false"
                [closable]="true"
            >
                <form #formTransf="ngForm" name="formTransf">
                    <div class="formgroup">
                        <div class="p-fluid p-formgrid grid" *ngIf="!caixaSelecionado">
                            <div class="field col-12 md:col-12 shadow-2 border-round-lg">
                                <div class="flex flex-row gap-4 md:flex-column overflow-auto">
                                    <div class="justify-content-center mt-5">
                                        <label for="">
                                            <i class="pi pi-times"></i>
                                            Por favor, selecione um Caixa
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="p-fluid p-formgrid grid" *ngIf="caixaSelecionado">
                            <div class="field col-12 md:col-12">
                                <label for="">Data</label>
                                <label for="" class="form-control">
                                    {{ caixaSelecionado.dataCaixa | date: "dd/MM/yyyy" }}
                                </label>
                            </div>

                            <div class="field col-12 md:col-6">
                                <label htmlFor="nome">Conta Origem</label>
                                <label
                                    *ngIf="
                                        tiposPagamentoSangriaOrigem.length === 1;
                                        else dropdownOrigem
                                    "
                                    class="form-control"
                                >
                                    {{ tipoPagamentoOrigemSelecionado?.descricao }}
                                </label>
                                <ng-template #dropdownOrigem>
                                    <p-dropdown
                                        [options]="tiposPagamentoSangriaOrigem"
                                        optionLabel="descricao"
                                        emptyFilterMessage="Nenhum registro"
                                        name="contaOrigem"
                                        ngModel
                                        #contaOrigem="ngModel"
                                        emptyMessage="Nenhum registro"
                                        [(ngModel)]="tipoPagamentoOrigemSelecionado"
                                    ></p-dropdown>
                                </ng-template>
                            </div>
                            <div class="field col-12 md:col-6">
                                <label htmlFor="nome">Conta Destino</label>
                                <label
                                    *ngIf="
                                        tiposPagamentoSangriaDestino.length === 1;
                                        else dropdownDestino
                                    "
                                    class="form-control"
                                >
                                    {{ tipoPagamentoDestinoSelecionado?.descricao }}
                                </label>
                                <ng-template #dropdownDestino>
                                    <p-dropdown
                                        [options]="tiposPagamentoSangriaDestino"
                                        optionLabel="descricao"
                                        emptyFilterMessage="Nenhum registro"
                                        name="contaDestino"
                                        ngModel
                                        #contaDestino="ngModel"
                                        emptyMessage="Nenhum registro"
                                        [(ngModel)]="tipoPagamentoDestinoSelecionado"
                                    ></p-dropdown>
                                </ng-template>
                            </div>
                            <div class="field col-12 md:col-12">
                                <label htmlFor="nome">Valor</label>
                                <p-inputNumber
                                    name="valor"
                                    ngModel
                                    #valor="ngModel"
                                    mode="currency"
                                    inputId="currency-brazil"
                                    currency="BRL"
                                    locale="pt-BR"
                                    [allowEmpty]="true"
                                    [required]="true"
                                    [(ngModel)]="valorSangria"
                                ></p-inputNumber>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="p-fluid p-formgrid grid justify-content-start">
                    <div
                        class="field col-12 md:col-4"
                        style="padding-bottom: 0px; margin-bottom: 0px"
                    >
                        <button
                            type="button"
                            pButton
                            [icon]="loadingSangria ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
                            label="Transferir"
                            class="p-button-outlined p-button-success"
                            (click)="transferir()"
                            [disabled]="!caixaSelecionado"
                        ></button>
                    </div>
                </div>
            </p-dialog>

            <p-dialog
                header="Saídas"
                [(visible)]="exibirDialogSaida"
                [modal]="true"
                [style]="{ width: '40rem' }"
                [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
                [draggable]="false"
                [resizable]="false"
                [closable]="true"
            >
                <div class="formgroup">
                    <div class="p-fluid p-formgrid grid" *ngIf="!caixaSelecionado">
                        <div class="field col-12 md:col-12 shadow-2 border-round-lg">
                            <div class="flex flex-row gap-4 md:flex-column overflow-auto">
                                <div class="justify-content-center mt-5">
                                    <label for="">
                                        <i class="pi pi-times"></i>
                                        Por favor, selecione um Caixa
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-fluid p-formgrid grid" *ngIf="caixaSelecionado">
                        <div
                            class="field col-12 md:col-4"
                            style="padding-bottom: 5px; margin-bottom: 5px"
                        >
                            <button
                                pButton
                                pRipple
                                label="Novo"
                                (click)="abrirDialogSaidaInserir()"
                                icon="pi pi-plus"
                                class="p-button-outlined"
                            ></button>
                        </div>
                        <div class="field col-12 md:col-12" *ngIf="messagemVisivelDialog">
                            <p-messages
                                [(value)]="messagesDialog"
                                [enableService]="false"
                                [closable]="true"
                            ></p-messages>
                        </div>
                        <div
                            class="field col-12 md:col-12"
                            style="padding: 1px 14px; margin-bottom: 0px"
                        >
                            <label for="">Data</label>
                            <label for="" class="form-control">
                                {{ caixaSelecionado.dataCaixa | date: "dd/MM/yyyy" }}
                            </label>
                        </div>

                        <div
                            class="field col-12 md:col-12"
                            style="padding: 0px 14px 0px; margin-bottom: 0px"
                        >
                            <p-table
                                #dtSaidas
                                [value]="listaSaidasCaixa"
                                dataKey="id"
                                [rows]="5"
                                [rowHover]="true"
                                [loading]="loadingSaida"
                                styleClass="p-datatable-gridlines"
                                [paginator]="true"
                                [globalFilterFields]="['descricao']"
                                responsiveLayout="scroll"
                                styleClass=" p-datatable-sm"
                            >
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th pSortableColumn="identificacao">
                                            Identificação
                                            <p-sortIcon field="identificacao"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="valorFluxo">
                                            Valor
                                            <p-sortIcon field="valorFluxo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="tipoPagamento.descricao">
                                            Tipo Pagamento
                                            <p-sortIcon
                                                field="tipoPagamento.descricao"
                                            ></p-sortIcon>
                                        </th>
                                        <th style="text-align: center">
                                            <div>Ações</div>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td>
                                            {{ item.identificacao }}
                                        </td>
                                        <td>
                                            {{ item.valorFluxo | currency: "BRL" }}
                                        </td>
                                        <td>
                                            {{ item.tipoPagamento.descricao }}
                                        </td>

                                        <td style="text-align: center">
                                            <button
                                                pButton
                                                pRipple
                                                pTooltip="Excluir"
                                                icon="pi pi-trash"
                                                class="p-button-danger"
                                                (click)="excluirSaida(item.id)"
                                            ></button>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="7">Nenhum registro encontrado.</td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="loadingbody">
                                    <tr>
                                        <td colspan="7">Carregando grupos. Por favor aguarde.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </p-dialog>
            <p-dialog
                header="Saídas"
                [(visible)]="exibirDialogSaidaInserir"
                [modal]="true"
                [style]="{ width: '40rem' }"
                [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
                [draggable]="false"
                [resizable]="false"
                [closable]="true"
            >
                <form #formSaidaInserir="ngForm" name="formSaidaInserir">
                    <div class="formgroup">
                        <div class="p-fluid p-formgrid grid" *ngIf="!caixaSelecionado">
                            <div class="field col-12 md:col-12 shadow-2 border-round-lg">
                                <div class="flex flex-row gap-4 md:flex-column overflow-auto">
                                    <div class="justify-content-center mt-5">
                                        <label for="">
                                            <i class="pi pi-times"></i>
                                            Por favor, selecione um Caixa
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="p-fluid p-formgrid grid" *ngIf="caixaSelecionado">
                            <div class="field col-12 md:col-12">
                                <label for="">Data</label>
                                <label for="" class="form-control">
                                    {{ caixaSelecionado.dataCaixa | date: "dd/MM/yyyy" }}
                                </label>
                            </div>

                            <div class="field col-12 md:col-12">
                                <label>Tipo de Pagamento</label>
                                <p-dropdown
                                    [options]="listaTipoPagamentoSaida"
                                    optionLabel="descricao"
                                    emptyFilterMessage="Nenhum registro"
                                    name="tpPagamentoSaida"
                                    ngModel
                                    #tpPagamentoSaida="ngModel"
                                    emptyMessage="Nenhum registro"
                                    [(ngModel)]="tipoPagamentoSaidaSelecionado"
                                ></p-dropdown>
                            </div>
                            <div class="field col-12 md:col-12">
                                <label htmlFor="identificacao">Identificação</label>
                                <input
                                    oninput="this.value = this.value.toUpperCase();"
                                    type="text"
                                    pInputText
                                    placeholder="Insira a Identificação"
                                    name="identificacao"
                                    ngModel
                                    #identificacao="ngModel"
                                    [(ngModel)]="identificacaoSaida"
                                />
                            </div>
                            <div class="field col-12 md:col-12">
                                <label htmlFor="nome">Valor</label>
                                <p-inputNumber
                                    name="valor"
                                    ngModel
                                    #valor="ngModel"
                                    mode="currency"
                                    inputId="currency-brazil"
                                    currency="BRL"
                                    locale="pt-BR"
                                    [allowEmpty]="true"
                                    [required]="true"
                                    [(ngModel)]="valorSaida"
                                ></p-inputNumber>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="p-fluid p-formgrid grid justify-content-start">
                    <div
                        class="field col-12 md:col-4"
                        style="padding-bottom: 0px; margin-bottom: 0px"
                    >
                        <button
                            type="button"
                            pButton
                            [icon]="loadingSaidaInserir ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
                            label="Confirmar"
                            class="p-button-outlined p-button-success"
                            (click)="salvarSaida()"
                            [disabled]="!caixaSelecionado"
                        ></button>
                    </div>
                </div>
            </p-dialog>

            <p-dialog
                header="Pagamentos"
                [(visible)]="exibirDialogPagamentoListar"
                [modal]="true"
                [style]="{ width: '50rem', paddingBottom: '0px' }"
                [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
                [draggable]="false"
                [resizable]="false"
                [closable]="true"
            >
                <div class="formgroup">
                    <div class="p-fluid p-formgrid grid" *ngIf="!caixaSelecionado">
                        <div class="field col-12 md:col-12 shadow-2 border-round-lg">
                            <div class="flex flex-row gap-4 md:flex-column overflow-auto">
                                <div class="justify-content-center mt-5">
                                    <label for="">
                                        <i class="pi pi-times"></i>
                                        Por favor, selecione um Caixa
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-fluid p-formgrid grid" *ngIf="caixaSelecionado">
                        <div
                            class="field col-12 md:col-4"
                            style="padding-bottom: 5px; margin-bottom: 5px"
                        >
                            <button
                                pButton
                                pRipple
                                label="Novo"
                                (click)="abrirDialogPagamentosInserir()"
                                icon="pi pi-plus"
                                class="p-button-outlined"
                            ></button>
                        </div>
                        <div class="field col-12 md:col-12" *ngIf="messagemVisivelDialog">
                            <p-messages
                                [(value)]="messagesDialog"
                                [enableService]="false"
                                [closable]="true"
                            ></p-messages>
                        </div>
                        <div
                            class="field col-12 md:col-12"
                            style="padding: 1px 14px; margin-bottom: 0px"
                        >
                            <label for="">Data</label>
                            <label for="" class="form-control">
                                {{ caixaSelecionado.dataCaixa | date: "dd/MM/yyyy" }}
                            </label>
                        </div>
                        <div
                            class="field col-12 md:col-12"
                            style="padding: 0px 14px; margin-bottom: 0px"
                        >
                            <p-table
                                #dtPagamentos
                                [value]="listaDespesasPagas"
                                dataKey="id"
                                [rows]="5"
                                [rowHover]="true"
                                [loading]="loadingPagamentosListar"
                                styleClass="p-datatable-gridlines"
                                [paginator]="true"
                                [globalFilterFields]="['descricao']"
                                responsiveLayout="scroll"
                                styleClass=" p-datatable-sm"
                            >
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th pSortableColumn="identificacao">
                                            Identificação
                                            <p-sortIcon field="identificacao"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="valorFluxo">
                                            Valor
                                            <p-sortIcon field="valorFluxo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="tipoPagamento.descricao">
                                            Tipo Pagamento
                                            <p-sortIcon
                                                field="tipoPagamento.descricao"
                                            ></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="valorFluxo">
                                            Vencimento
                                            <p-sortIcon field="valorFluxo"></p-sortIcon>
                                        </th>
                                        <th>Ações</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td>
                                            {{ item.identificacao }}
                                        </td>
                                        <td>
                                            {{ item.valorFluxo | currency: "BRL" }}
                                        </td>
                                        <td>
                                            {{ item.tipoPagamento?.descricao }}
                                        </td>
                                        <td>
                                            {{ item.dataVencimento | date: "dd/MM/yyyy" }}
                                        </td>
                                        <td style="text-align: center">
                                            <button
                                                pButton
                                                pRipple
                                                pTooltip="Estornar"
                                                icon="pi pi-replay"
                                                class="p-button-info"
                                                (click)="estornarDespesa(item)"
                                            ></button>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="7">Nenhum registro encontrado.</td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="loadingbody">
                                    <tr>
                                        <td colspan="7">Carregando grupos. Por favor aguarde.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </p-dialog>
            <p-dialog
                header="Pagamentos"
                [(visible)]="exibirDialogPagamentos"
                [modal]="true"
                [style]="{ width: '50rem' }"
                [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
                [draggable]="false"
                [resizable]="false"
                [closable]="true"
            >
                <div class="flex justify-content-center" *ngIf="!caixaSelecionado">
                    <div class="field col-12 md:col-12 shadow-2 border-round-lg">
                        <div class="flex flex-row gap-4 md:flex-column overflow-auto">
                            <label for="">
                                <i class="pi pi-times"></i>
                                Por favor, selecione um Caixa
                            </label>
                        </div>
                    </div>
                </div>

                <div class="p-fluid p-formgrid grid" *ngIf="caixaSelecionado">
                    <div class="field col-12 md:col-12" *ngIf="etapaPagamento">
                        <label for="">Data</label>
                        <label for="" class="form-control">
                            {{ caixaSelecionado.dataCaixa | date: "dd/MM/yyyy" }}
                        </label>
                    </div>
                    <div class="field col-12 md:col-12" *ngIf="etapaPagamento">
                        <label for="">Tipo Pagamento</label>
                        <p-dropdown
                            [options]="listaTipoPagamentoDespesa"
                            optionLabel="descricao"
                            emptyFilterMessage="Nenhum registro"
                            name="tpPagamentoDespesa"
                            ngModel
                            #tpPagamentoSaida="ngModel"
                            emptyMessage="Nenhum registro"
                            [(ngModel)]="tipoPagamentoDespesaSelecionado"
                        ></p-dropdown>
                    </div>
                    <div class="field col-12 md:col-6" *ngIf="etapaPagamento">
                        <label for="">Identificação</label>
                        <label for="" class="form-control">
                            {{ despesaSelecionada?.identificacao }}
                        </label>
                    </div>
                    <div class="field col-12 md:col-6" *ngIf="etapaPagamento">
                        <label for="">Valor</label>
                        <label for="" class="form-control">
                            {{ despesaSelecionada?.valorFluxo | currency: "BRL" }}
                        </label>
                    </div>

                    <div
                        class="field col-12 md:col-12"
                        *ngIf="!etapaPagamento"
                        style="padding: 14px 14px 0px; margin: 0px"
                    >
                        <p-table
                            #dtDespesas
                            [value]="listaDespesasEmAberto"
                            dataKey="id"
                            [rows]="5"
                            [loading]="loadingPagamentos"
                            [rowHover]="true"
                            styleClass="p-datatable-gridlines"
                            [paginator]="true"
                            [globalFilterFields]="['planoContaEmpresa.descricao', 'identificacao']"
                            responsiveLayout="scroll"
                            styleClass=" p-datatable-sm"
                        >
                            <ng-template pTemplate="caption">
                                <div class="flex justify-content-between flex-column sm:flex-row">
                                    <p-dropdown
                                        [options]="filtroMesesPagamentos"
                                        emptyFilterMessage="Nenhum registro"
                                        name="caixas"
                                        ngModel
                                        #caixas="ngModel"
                                        emptyMessage="Nenhum registro"
                                        [(ngModel)]="filtroMesSelecionado"
                                        (onChange)="listarPagamentosDespesa()"
                                    ></p-dropdown>

                                    <div></div>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="header">
                                <tr>
                                    <th pSortableColumn="identificacao">
                                        Identificação
                                        <p-sortIcon field="identificacao"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="dataVencimento">
                                        Vencimento
                                        <p-sortIcon field="dataVencimento"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="valorFluxo">
                                        Valor
                                        <p-sortIcon field="valorFluxo"></p-sortIcon>
                                    </th>
                                    <th style="text-align: center">
                                        <div>Ações</div>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-item>
                                <tr>
                                    <td>
                                        {{ item.identificacao }}
                                    </td>
                                    <td>
                                        {{ item.dataVencimento | date: "dd/MM/yyyy" }}
                                    </td>
                                    <td>
                                        {{ item.valorFluxo | currency: "BRL" }}
                                    </td>

                                    <td style="text-align: center">
                                        <button
                                            *ngIf="
                                                verificarPermissao('PERM_PAGAR_PAGAMENTO_DESPESA')
                                            "
                                            pButton
                                            pRipple
                                            pTooltip="Pagar"
                                            (click)="selecionarDespesa(item)"
                                            icon="pi pi-dollar"
                                            class="p-button-success mr-2 mb-2"
                                        ></button>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="7">Nenhum registro encontrado.</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="loadingbody">
                                <tr>
                                    <td colspan="7">Carregando contratos. Por favor aguarde.</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>

                <div class="p-fluid p-formgrid grid justify-content-between" *ngIf="etapaPagamento">
                    <div class="col-12 md:col-4 margem-zero-field">
                        <button
                            type="button"
                            pButton
                            [icon]="
                                progressoRequisicaoPagamento
                                    ? 'pi pi-spin pi-spinner'
                                    : 'pi pi-check'
                            "
                            label="Pagar"
                            class="p-button-outlined p-button-success"
                            (click)="pagarDespesa()"
                        ></button>
                    </div>

                    <div class="col-12 md:col-4 margem-zero-field">
                        <button
                            type="button"
                            pButton
                            icon="pi pi-arrow-left"
                            label="Voltar"
                            class="p-button-outlined"
                            [disabled]="progressoRequisicaoPagamento"
                            (click)="etapaPagamento = false"
                        ></button>
                    </div>
                </div>
            </p-dialog>
        </div>
    </div>
</div>
